import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { theme } from '../theme';
import { useIsMobile } from '../hooks/useMediaQuery';

function PagoResultado() {
  const isMobile = useIsMobile();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('LOADING');
  const [reviewId, setReviewId] = useState(null); // número de pedido/cita para calificar

  const sku = searchParams.get('sku');
  const id = searchParams.get('id');
  const tienda = searchParams.get('tienda'); // si el pago vino de una tienda pública
  const cita = searchParams.get('cita');     // si el pago vino del agendamiento de citas

  // A dónde vuelve el botón final, según el origen del pago.
  const back = cita
    ? { to: `/cita/${cita}`, label: 'Volver al agendamiento' }
    : tienda
      ? { to: `/tienda/${tienda}`, label: 'Volver a la tienda' }
      : { to: '/', label: 'Volver al inicio' };

  useEffect(() => {
    if (!sku) { setStatus('ERROR'); return; }
    fetch(`/api/pay/resultado?sku=${encodeURIComponent(sku)}${id ? `&id=${encodeURIComponent(id)}` : ''}`)
      .then(r => r.ok ? r.json() : { status: 'ERROR' })
      .then(d => { setStatus(d.status || 'ERROR'); setReviewId(d.appointment_id ?? d.order_id ?? null); })
      .catch(() => setStatus('ERROR'));
  }, [sku, id]);

  const config = {
    LOADING:   { icon: '⏳', color: theme.colors.textMuted, title: 'Verificando pago...', msg: 'Por favor espera.' },
    APPROVED:  { icon: '✅', color: theme.colors.success,   title: 'Pago aceptado',      msg: 'Tu pago fue procesado exitosamente.' },
    DECLINED:  { icon: '❌', color: theme.colors.error,     title: 'Pago rechazado',     msg: 'El pago no pudo ser procesado.' },
    NOT_FOUND: { icon: '🔍', color: theme.colors.textMuted, title: 'Pago no encontrado', msg: 'No encontramos información de este pago.' },
    ERROR:     { icon: '⚠️', color: '#f59e0b',              title: 'Error',              msg: 'Ocurrió un error al verificar el pago.' },
  };
  const c = config[status] || config.ERROR;

  return (
    <main style={{ padding: isMobile ? '2rem 1rem' : '3rem 1.5rem', display: 'flex', justifyContent: 'center' }}>
      <div style={{
        backgroundColor: theme.colors.surface, borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`, padding: isMobile ? '1.75rem 1.25rem' : '2.5rem',
        width: '100%', maxWidth: '420px', textAlign: 'center',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>{c.icon}</div>
        <h1 style={{ color: c.color, fontSize: '1.5rem', marginBottom: '0.5rem' }}>{c.title}</h1>
        <p style={{ color: theme.colors.textMuted, fontSize: '0.95rem', lineHeight: '1.7', marginBottom: status === 'APPROVED' && reviewId != null ? '1.2rem' : '2rem' }}>{c.msg}</p>
        {status === 'APPROVED' && reviewId != null && (
          <div style={{ backgroundColor: theme.colors.background, border: `2px dashed ${theme.colors.primary}`, borderRadius: '12px', padding: '1.1rem', marginBottom: '2rem', textAlign: 'center' }}>
            <p style={{ color: theme.colors.textMuted, fontSize: '0.85rem', margin: '0 0 0.3rem' }}>📌 El número de tu {cita ? 'cita' : 'pedido'} es</p>
            <div style={{ color: theme.colors.primary, fontSize: '2.2rem', fontWeight: 800, fontFamily: 'monospace', letterSpacing: '1px' }}>#{reviewId}</div>
            <p style={{ color: theme.colors.text, fontSize: '0.88rem', lineHeight: 1.55, margin: '0.6rem 0 0' }}>
              ⭐ ¡Guarda este número! Con él podrás <strong>calificar y comentar</strong> el {cita ? 'servicio' : 'producto'} que adquiriste. No lo pierdas.
            </p>
          </div>
        )}
        {status !== 'LOADING' && (
          <button
            onClick={() => navigate(back.to)}
            style={{ padding: '11px 32px', backgroundColor: theme.colors.primary, color: theme.colors.background, border: 'none', borderRadius: '7px', fontSize: '1rem', fontWeight: '700', cursor: 'pointer' }}
          >
            {back.label}
          </button>
        )}
      </div>
    </main>
  );
}

export default PagoResultado;
